"use client";
import React, { useState } from "react";
import { COMPANY_DISCORD_INVITE_LINK } from "@/constants/sleapContact";
import { useWalletService } from "../../context/walletServiceContext/walletServiceContext";
import { ThirdWeb } from "../../components/common/Loader/ThirdWeb";
import { useTheme } from "next-themes";
import { useTranslations } from "next-intl";

export default function CtaBanner() {
  const { userDetails } = useWalletService();
  const t = useTranslations();

  const { resolvedTheme } = useTheme();

  const { walletId } = userDetails;
  return (
    <>
      <div className="container py-8 lg:py-16 flex justify-center">
        <div className="flex flex-col w-10/12 lg:w-8/12 rounded-3xl bg-gradient-to-r from-primary to-secondary p-6 lg:p-16 gap-6">
          <h5 className="text-lg lg:text-4xl text-center text-lightwhite">
            {t("AboutPage.ctaDescription")}
          </h5>
          <div className="flex gap-2 justify-center">
            {!walletId && (
              <button className="bg-zinc-900 h-10 lg:h-11 px-0">
                <ThirdWeb
                  theme={resolvedTheme ?? ""}
                  walletId={walletId}
                  label={t("Other.signIn")}
                  className="!min-w-5 !text-lightwhite !h-auto !font-unbounded !font-medium flex justify-center items-center !px-6"
                />
              </button>
            )}

            <button className="bg-zinc-900 h-10 lg:h-11">
              <a href={`${COMPANY_DISCORD_INVITE_LINK}`} target="_blank">
                <h5 className="text-sm xl:text-base text-lightwhite">
                  {t("AboutPage.ctaButton")}
                </h5>
              </a>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
